const login = {
  mode: "ko",
  title: "로그인 | 국제인",
  description: "국제인에 로그인하세요. 숙련된 개발자와 연결되어 다양한 가능성을 경험해보세요. 최고 수준의 개발자 서비스를 만나보세요.",
  subtitle: "글로벌 해외 개발자 매칭 플랫폼",
  google: "Google 계정으로 로그인",
  or: "또는",
  username: "이메일 주소",
  password: "비밀번호",
  login: "로그인",
  loading: "로딩중...",
  rememberMe: "로그인 유지",
  forgotPassword: "비밀번호 찾기",
  notAMember: "아이디가 없으신가요?",
  signUp: "회원가입",
  error: {
    unknown: "잠시 후 시도해주세요",
    unregistered: "이메일 또는 비밀번호가 틀렸습니다",
    wrong: "이메일 또는 비밀번호가 틀렸습니다",
    invalidFormat: "올바른 이메일 형식이 아닙니다"
  }
};

export default login;
